import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { call } from "./common";

export default function ImportDialog({ types, onClose, onDone }) {
  const [file, setFile] = useState(null);
  const [text, setText] = useState("");
  const [et, setEt] = useState("not_found");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    const fd = new FormData();
    if (file) fd.append("file", file);
    fd.append("text", text);
    fd.append("error_type", et);
    setBusy(true);
    const r = await call(() => api.post("/admin/url-repair/import", fd), (d) => `${d.added} URLs imported and checked${d.skipped ? `, ${d.skipped} skipped` : ""}`);
    setBusy(false);
    if (r) { onDone(); onClose(); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-lg" data-testid="ur-import-dialog">
        <DialogHeader><DialogTitle>Import Search Console URLs</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">In Search Console open Indexing → Pages, click a reason (e.g. "Not found (404)"), then Export → Download CSV. Upload it here, or paste URLs one per line.</p>
        <label className="text-sm font-semibold text-steel">Issue type in this file</label>
        <select value={et} onChange={(e) => setEt(e.target.value)} className="h-9 rounded-md border px-2 text-sm bg-white" data-testid="ur-import-type">
          {Object.entries(types).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        <input type="file" accept=".csv,text/csv,text/plain" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="ur-import-file" className="text-sm" />
        <Textarea rows={5} value={text} onChange={(e) => setText(e.target.value)} placeholder={"https://acponline.co.nz/product/old-url\n/product/another-old-url"} className="font-mono text-xs" data-testid="ur-import-text" />
        <p className="text-[11px] text-muted-foreground">"Not indexed" reports are checked but never redirected if the page works.</p>
        <Button disabled={busy || (!file && !text.trim())} onClick={go} className="bg-steel text-white" data-testid="ur-import-submit">{busy && <Loader2 size={15} className="mr-1 animate-spin" />}Import &amp; match</Button>
      </DialogContent>
    </Dialog>
  );
}
